import slugify from 'slugify';
import { Template, parseTemplate } from 'url-template';

export const HomePageUrl = '/';

export const AuthCallbackPageUrl = '/';

/**
 * /{market}/requests
 * @param market
 */
export const RequestsPageUrl = parseTemplate('/{market}/requests{?statusCategory,status,search}');

/**
 * /{market}/requests/{requestId}
 * @param market
 * @param requestId
 */
export const SearchEimPageUrl = parseTemplate('/{market}/requests/{requestId}');

/**
 * /{market}/requests/{requestId}/{eim}?{issueId}
 * @param market
 * @param requestId
 * @param eim
 */
export const RequestPageUrl = parseTemplate('/{market}/requests/{requestId}/{eim}{?issueId,f}');

/**
 * /{market}/requests/{requestId}/{eim}/{camera}{?issueId,waypoint}
 * @param market
 * @param requestId
 * @param eim
 */
export const RequestCameraPageUrl = parseTemplate('/{market}/requests/{requestId}/{eim}/{camera}{?issueId,waypoint,f}');

/**
 * @function
 * Expands url as react-route path.
 * @param {Template} url - Template url to be expended. It cannot contain '--'.
 * @param {string[]} params - urls params.
 * @returns {string} parameterized path.
 */
export const expandAsPath = (url: Template, ...params: string[]) => {
  const context = params.reduce((prev, param) => {
    return {
      ...prev,
      [param]: `--${param}`,
    };
  }, {});

  const routerUrl = url.expand(context).replace(/--/g, ':');
  return routerUrl;
};

export const MakeURLFriendly = (value?: string | null) => {
  return slugify(value || '');
}
